export default class SendKeypadDigits {
  constructor(context) {
    this.context = context;
  }

  run(digits) {
    this.context.gateways.phoneGateway.sendDigits(digits);
  }
}
